export const languages = [
  {
    code: 'en',
    label: 'english',
    flag: '/assets/images/united-states.png',
  },
  {
    code: 'fr',
    label: 'french',
    flag: '/assets/images/france.png',
  },
];
